export const getTestingFeeByMemberId = (members = [], fees = {}) => {
  const map = {};
  if (!Array.isArray(members)) return map;

  members.forEach((member) => {
    const id = String(member?._id || member?.id || "");
    if (!id) return;
    const degreeValue = Number(member?.degree);
    if (!Number.isFinite(degreeValue)) return;
    // Testing fees are stored by the target grade (next degree).
    const feeKey = String(degreeValue + 2);
    const feeValue = fees?.[feeKey];
    if (Number.isFinite(Number(feeValue))) {
      map[id] = Number(feeValue);
    }
  });

  return map;
};
